/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfacePrizeItem } from './SurfacePrizeItem';
import {
    SurfacePrizeItemFromJSON,
    SurfacePrizeItemFromJSONTyped,
    SurfacePrizeItemToJSON,
    SurfacePrizeItemToJSONTyped,
} from './SurfacePrizeItem';

/**
 * 
 * @export
 * @interface SurfacePrizesConfig
 */
export interface SurfacePrizesConfig {
    /**
     * 
     * @type {Array<SurfacePrizeItem>}
     * @memberof SurfacePrizesConfig
     */
    prizes?: Array<SurfacePrizeItem>;
    /**
     * 
     * @type {string}
     * @memberof SurfacePrizesConfig
     */
    layout?: SurfacePrizesConfigLayoutEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SurfacePrizesConfig
     */
    showValues?: boolean;
}


/**
 * @export
 */
export const SurfacePrizesConfigLayoutEnum = {
    carousel: 'carousel',
    grid: 'grid',
    featured: 'featured'
} as const;
export type SurfacePrizesConfigLayoutEnum = typeof SurfacePrizesConfigLayoutEnum[keyof typeof SurfacePrizesConfigLayoutEnum];


/**
 * Check if a given object implements the SurfacePrizesConfig interface.
 */
export function instanceOfSurfacePrizesConfig(value: object): value is SurfacePrizesConfig {
    return true;
}

export function SurfacePrizesConfigFromJSON(json: any): SurfacePrizesConfig {
    return SurfacePrizesConfigFromJSONTyped(json, false);
}

export function SurfacePrizesConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfacePrizesConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'prizes': json['prizes'] == null ? undefined : ((json['prizes'] as Array<any>).map(SurfacePrizeItemFromJSON)),
        'layout': json['layout'] == null ? undefined : json['layout'],
        'showValues': json['showValues'] == null ? undefined : json['showValues'],
    };
}

export function SurfacePrizesConfigToJSON(json: any): SurfacePrizesConfig {
    return SurfacePrizesConfigToJSONTyped(json, false);
}

export function SurfacePrizesConfigToJSONTyped(value?: SurfacePrizesConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'prizes': value['prizes'] == null ? undefined : ((value['prizes'] as Array<any>).map(SurfacePrizeItemToJSON)),
        'layout': value['layout'],
        'showValues': value['showValues'],
    };
}

